import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // i18n 불러오기
import { noticeList } from '../../data/NoticeData';
import NoticeComponent from '../../components/NoticeComponent';
import { Services_ARR } from '../../data';
import { IoCloseOutline } from 'react-icons/io5';
import { RiCustomerService2Line } from 'react-icons/ri';
import { CgList } from 'react-icons/cg';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const NoticePage = () => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const titleVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0 } },
  };

  const subtitleVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0.5 } },
  };

  const serviceicon = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0.5 } },
  };

  const MessageEmoji = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0.5 } },
  };

  const servicebox = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0.5 } },
  };

  const Messagebox = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 0.8 } },
  };

  const an = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 1 } },
  };

  return (
    <div
      className="max-w-[2560px] w-full mx-auto mt-[58px] pb-[80px] mobile:pb-[30px]"
    >
      <section>
        <div className=" relative w-full py-[100px] mobile:pb-[80px]">

          <motion.div
            className="relative mx-auto  text-center overflow-hidden text-[#000]"
            variants={titleVariants}
            initial="hidden"
            animate="visible"
          >
            {/* <div className="flex justify-center">
            <RiCustomerService2Line className="text-[90px] group-hover:text-MainColor group-hover:animate-wiggle transition duration-500" />
          </div> */}

            <h1 className="ChosunGu mt-[30px] text-[42px] mobile:text-[28px] font-bold">
              안녕하세요.
              <br />
              무엇을 도와드릴까요?
            </h1>
          </motion.div>
          {/* <span className="block mt-8 text-lg text-[#1e1e1e] leading-8">
            고객님께서는 언제든지 저희 고객센터를 통해 문의하실 수 있습니다.
            <br />
            저희는 여러분의 문의사항에 신속하고 정확하게 답변해 드리기 위해
            최선을 다하고 있습니다.
          </span> */}

          <motion.span
            className="ChosunGu block text-center mobile:flex mobile:justify-center tracking-wide mt-4 text-sm text-[#b7b7b7] leading-7 mobile:leading-[23px] mobile:text-[11px]"
            variants={subtitleVariants}
            initial="hidden"
            animate="visible"
          >
            {/* 서비스 제공사가 크리에이터 유닛 스토어가 아닌 지역의 경우 해당
            지역 서비스 제공사의 고객센터를 이용하실 수 있습니다. */}
            <div className='mobile:text-wrap mobile:w-[230px] '>
              공지사항 및 자주 묻는 질문에 대한 궁금한 점이 있으시면 언제든지
              문의해 주세요.
              <br />
              전문 지원 인력이 신속하게 답변해드리며, 필요한 정보를 빠르고
              정확하게 제공해 드립니다.
            </div>
          </motion.span>

          <motion.div
            className="absolute top-[50%] right-[28%] mobile:top-[30%] mobile:right-[10%] translate-x-[50%]"
            variants={MessageEmoji}
            initial="hidden"
            animate="visible"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={58}
              height={58}
              viewBox="0 0 48 48"
              className='mobile:w-[34px] mobile:h-[34px]'
            >
              <defs>
                <mask id="ipSMessageEmoji0">
                  <g
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={4}
                  >
                    <path
                      fill="#fff"
                      stroke="#fff"
                      d="M44 7H4v30h7v5l10-5h23z"
                    ></path>
                    <path
                      stroke="#000"
                      d="M31 16v1m-14-1v1m14 8s-2 4-7 4s-7-4-7-4"
                    ></path>
                  </g>
                </mask>
              </defs>
              <path
                fill="#f2de02"
                d="M0 0h48v48H0z"
                mask="url(#ipSMessageEmoji0)"
              ></path>
            </svg>
          </motion.div>

          <motion.div
            className="absolute top-[35%] left-[29%] mobile:top-[65%] mobile:left-[8%] translate-x-[50%]"
            variants={serviceicon}
            initial="hidden"
            animate="visible"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={54}
              height={54}
              viewBox="0 0 24 24"
              className='mobile:w-[34px] mobile:h-[34px]'
            >
              <path
                fill="#02c2f2"
                d="M2 11C2 5.477 6.477 1 12 1s10 4.477 10 10v5.154C22 17.8 20.58 19 19 19h-3v-8h4a8 8 0 1 0-16 0h4v8H6.063A2 2 0 0 0 8 20.5h1.564c.316-.453.841-.75 1.436-.75h2a1.75 1.75 0 1 1 0 3.5h-2c-.595 0-1.12-.297-1.436-.75H8a4 4 0 0 1-3.986-3.66C2.874 18.463 2 17.446 2 16.155zm4 6v-4H4v3.154c0 .393.37.846 1 .846zm14-4h-2v4h1c.63 0 1-.453 1-.846z"
              ></path>
            </svg>
          </motion.div>
        </div>

        <div className="flex justify-center gap-[100px] mobile:gap-4 mobile:grid mobile:grid-rows-2 items-center h-1/2 mobile:px-4">
          <motion.div
            className="relative shadow-lg border border-[#f6f6f6] rounded-xl w-[300px] h-[300px] mobile:h-[150px] flex justify-center"
            variants={servicebox}
            initial="hidden"
            animate="visible"
          >
            <button
              type="button"
              className="cursor-default text-[#111] transition duration-500 ease-in-out Pretendard-Medium text-2xl mobile:text-base"
            >
              공지사항
              <div
                onClick={() => handleNavigate('/notice/list')}
                className="text-blue-500  absolute !cursor-pointer bottom-[10px] left-[20px] text-[13px] mobile:text-[10px] Pretendard-Regular"
              >
                전체 보기 ⇢
              </div>
              <div className="absolute text-[60px]  bottom-[50px] right-[30px] mobile:text-[34px]  mobile:bottom-[30px]  mobile:right-[15px]">
                📢
              </div>
            </button>
          </motion.div>

          <motion.div
            className="relative flex justify-center border border-[#f6f6f6] shadow-lg rounded-xl w-[300px] h-[300px] mobile:h-[150px]"
            variants={Messagebox}
            initial="hidden"
            animate="visible"
          >
            <button
              type="button"
              className="cursor-default text-[#111]  tracking-wider transition duration-500 ease-in-out Pretendard-Medium text-2xl mobile:text-base"
            >
              FAQ
              <br />
              자주 묻는 질문
              <div
                onClick={() => handleNavigate('/cs')}
                className="text-blue-500 absolute !cursor-pointer bottom-[10px] left-[20px] text-[13px] mobile:text-[10px] Pretendard-Regular"
              >
                전체 보기 ⇢
              </div>
              <div className="absolute right-[30px] bottom-[30px] text-[60px] mobile:bottom-[15px]  mobile:right-[15px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={60}
                  height={60}
                  viewBox="0 0 48 48"
                  className='mobile:w-[42px] mobile:h-[42px]'
                >
                  <path
                    fill="#f3e652"
                    d="M15 40h23l6 6V25c0-2.2-1.8-4-4-4H15c-2.2 0-4 1.8-4 4v11c0 2.2 1.8 4 4 4"
                  ></path>
                  <path
                    fill="#bda345"
                    d="M28.8 32.8h-3.6l-.7 2.1h-2.2l3.7-10h1.9l3.7 10h-2.2zm-3.1-1.6h2.5L27 27.4z"
                  ></path>
                  <path
                    fill="#4bc1c3"
                    d="M33 25H10l-6 6V8c0-2.2 1.8-4 4-4h25c2.2 0 4 1.8 4 4v13c0 2.2-1.8 4-4 4"
                  ></path>
                  <path
                    fill="#fff"
                    d="M25.4 14.2c0 1-.2 1.8-.5 2.5s-.7 1.3-1.3 1.7l1.7 1.3l-1.3 1.2l-2.2-1.7c-.2 0-.5.1-.8.1q-.9 0-1.8-.3c-.5-.2-1-.6-1.4-1s-.7-1-.9-1.6q-.3-.9-.3-2.1v-.4q0-1.2.3-2.1c.2-.6.5-1.2.9-1.6s.8-.8 1.4-1q.75-.3 1.8-.3q.9 0 1.8.3c.5.2 1 .6 1.4 1s.7 1 .9 1.6q.3.9.3 2.1zm-2.2-.5q0-1.65-.6-2.4c-.4-.6-.9-.8-1.6-.8s-1.3.3-1.6.8q-.6.9-.6 2.4v.5c0 .5.1 1 .2 1.4s.2.8.4 1c.2.3.4.5.7.6s.6.2.9.2c.7 0 1.3-.3 1.6-.8c.4-.6.6-1.4.6-2.5z"
                  ></path>
                </svg>
              </div>
            </button>
          </motion.div>
        </div>



      </section>
    </div>
  );
};

export default NoticePage;
